module.exports = __webpack_public_path__ + "img/youtube.cca1120e.svg";